let clientConfig = {
  
}

export default clientConfig